export * from "./subgrupodeproduto-edit.component";
export * from "./subgrupodeproduto-browse.component";
